/** Open WhatsApp with a prefilled message and no recipient, so the user picks the chat or broadcast list. */
export const openWhatsApp = (text: string) =>
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener')
